import { PageLayout } from '@retail/components';
import { DashboardContainer } from '@retail/dashboard/containers';

export function DashboardPage() {
  return (
    <PageLayout maxWidth="full" fixedHeight sx={{ p: 0 }}>
      <DashboardContainer />
    </PageLayout>
  );
}
